/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripePaymentMethodGetResponse
 */
export interface StripePaymentMethodGetResponse {
    /**
     * See https://stripe.com/docs/api/payment_methods/object
     * @type {object}
     * @memberof StripePaymentMethodGetResponse
     */
    paymentMethod: object;
}

/**
 * Check if a given object implements the StripePaymentMethodGetResponse interface.
 */
export function instanceOfStripePaymentMethodGetResponse(value: object): value is StripePaymentMethodGetResponse {
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function StripePaymentMethodGetResponseFromJSON(json: any): StripePaymentMethodGetResponse {
    return StripePaymentMethodGetResponseFromJSONTyped(json, false);
}

export function StripePaymentMethodGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripePaymentMethodGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': json['paymentMethod'],
    };
}

export function StripePaymentMethodGetResponseToJSON(json: any): StripePaymentMethodGetResponse {
    return StripePaymentMethodGetResponseToJSONTyped(json, false);
}

export function StripePaymentMethodGetResponseToJSONTyped(value?: StripePaymentMethodGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethod': value['paymentMethod'],
    };
}

